import normalizeProduct from "../../utils/normalizations/normalize-product";
import { requireConfigValue } from "../../isomorphic-config";
const defaultImagesSize = requireConfigValue("imagesSize");
const defaultImagesQuality = requireConfigValue("imagesQuality");
export default function getAllProductsOperation({ commerce  }) {
    async function getAllProducts({ variables: getAllProductsVariables = {} , config: userConfig  } = {}) {
        //Uncomment the following line to debug
        /*     console.info(
      'getAllProducts called. Configuration: ',
      'getAllProductsVariables: ',
      getAllProductsVariables,
      'config: ',
      userConfig
    ) */ const first = getAllProductsVariables.first;
        const taxons = getAllProductsVariables.taxons;
        const imagesSize = getAllProductsVariables.imagesSize;
        const filter = {
            filter: {
                taxons: taxons == null ? void 0 : taxons.toString()
            }
        };
        const variables = {
            methodPath: "products.list",
            arguments: [
                {},
                {
                    include: "primary_variant,variants,images,option_types,variants.option_values,product_properties",
                    per_page: first,
                    ...filter,
                    image_transformation: {
                        quality: defaultImagesQuality,
                        size: imagesSize || defaultImagesSize
                    }
                }, 
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config // TODO: Send config.locale to Spree.
        ;
        const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
            variables
        });
        const normalizedProducts = spreeSuccessResponse.data.map((spreeProduct)=>normalizeProduct(spreeSuccessResponse, spreeProduct));
        return {
            products: normalizedProducts
        };
    }
    return getAllProducts;
};
